/* Watch Gallery wishlist: <wg-wishlist-button data-handle>.
   Stores product handles in localStorage (wg:wishlist). Buttons on the same page
   stay in sync through a custom event; state also survives across pages. */
(function () {
  if (customElements.get('wg-wishlist-button')) return;

  var KEY = 'wg:wishlist';

  function read() {
    try {
      var parsed = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable: state stays in memory for this page only */
    }
  }

  class WGWishlistButton extends HTMLElement {
    connectedCallback() {
      this.handle = this.getAttribute('data-handle');
      this.button = this.querySelector('button');
      if (!this.handle || !this.button) return;

      this.onClick = this.toggle.bind(this);
      this.onSync = this.render.bind(this);
      this.button.addEventListener('click', this.onClick);
      document.addEventListener('wg:wishlist:change', this.onSync);
      this.render();
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.onClick);
      document.removeEventListener('wg:wishlist:change', this.onSync);
    }

    get active() {
      return read().indexOf(this.handle) !== -1;
    }

    toggle(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      var list = read();
      var idx = list.indexOf(this.handle);
      if (idx === -1) list.unshift(this.handle);
      else list.splice(idx, 1);
      write(list);
      document.dispatchEvent(new CustomEvent('wg:wishlist:change', { detail: { handle: this.handle, list: list } }));
    }

    render() {
      var on = this.active;
      this.classList.toggle('is-active', on);
      this.button.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = on ? this.button.getAttribute('data-label-remove') : this.button.getAttribute('data-label-add');
      if (label) this.button.setAttribute('aria-label', label);
    }
  }

  customElements.define('wg-wishlist-button', WGWishlistButton);
})();
